import script from "./ScrollToTop.vue?vue&type=script&setup=true&lang=ts"
export * from "./ScrollToTop.vue?vue&type=script&setup=true&lang=ts"

import "./ScrollToTop.scss?vue&type=style&index=0&lang=scss&external"

const __exports__ = script;

export default __exports__